import React, { Component } from 'react';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import arrow from '../../assets/images/icons/arrow-left.svg';
import { headers, api_url } from '../../common/config';
import Carousel, { consts } from 'react-elastic-carousel';
import ImageCarousel from './imageCarousel';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import windowSize from 'react-window-size';
import Logo from '../../assets/images/logo/logo-h@2x.png';
class MediaCenterImages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            response: null,
            images: null,
            title: '',
            date: '',
            body: '',
            image: '',
        };
    }

    componentDidMount() {
        fetch(
            `${api_url}/autism/items/news_page_pictures/${this.props.match.params.id}?fields=*.*`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    response: res.data,
                    images: res.data.images,
                    title: res.data.title,
                    date: res.data.created_on,
                    body: res.data.body,
                    image: res.data.cover_image.data.full_url,
                });
            });
    }

    myArrow({ type, onClick, isEdge }) {
        const pointer =
            type === consts.PREV ? (
                <img
                    src={arrow}
                    alt=''
                    style={{ transform: 'rotate(180deg)' }}
                />
            ) : (
                <img src={arrow} alt='' />
            );
        return (
            <button onClick={onClick} disabled={isEdge} className='sliderBtn'>
                {pointer}
            </button>
        );
    }

    noArrow() {
        return <></>;
    }

    render() {
        let date = this.state.date.split(' ');
        let carousel = [''];
        if (this.state.images === null) {
            carousel = (
                <div className='img'>
                    <div className='fade'></div>
                </div>
            );
        } else {
            carousel = this.state.images.map((img) => (
                <ImageCarousel image={img.directus_files_id} />
            ));
        }

        const { t, i18n } = this.props;
        console.log(this.props);
        return (
            <div id='mediaCenterImages'>
                <Link to='/media' className='back'>
                    {i18n.language === 'ar' ? (
                        <img
                            src={arrow}
                            style={{
                                transform: 'rotate(180deg)',
                                filter: ' brightness(200%) ',
                            }}
                        />
                    ) : (
                        <img
                            src={arrow}
                            style={{
                                filter: ' brightness(200%) ',
                            }}
                        />
                    )}
                    <p>{t('back')}</p>
                </Link>
                <div
                    className='header'
                    style={{
                        backgroundImage: `linear-gradient(to bottom,
                            rgba(118, 112, 255, 0) 3%,
                            #7670ff
                        ), url(${this.state.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }}
                ></div>
                <div className='title'>
                    <p>{date[0]}</p>
                    <h1>{this.state.title}</h1>
                    <p>#صور</p>
                </div>
                {this.props.windowWidth > 900 ? (
                    <Carousel
                        className='carousel_wrapper'
                        itemsToShow={1}
                        // initialFirstItem={2}
                        pagination={false}
                        isRTL={true}
                        itemPadding={[40, 0]}
                        renderArrow={this.myArrow}
                    >
                        {carousel}
                    </Carousel>
                ) : (
                    <Carousel
                        className='carousel_wrapper'
                        itemsToShow={1}
                        // initialFirstItem={2}
                        pagination={false}
                        isRTL={true}
                        itemPadding={[40, 0]}
                        renderArrow={this.noArrow}
                    >
                        {carousel}
                    </Carousel>
                )}

                <div className='content_wrapper'>
                    <p
                        className='homepage-statement'
                        dangerouslySetInnerHTML={{
                            __html: this.state.body,
                        }}
                    />

                    {this.props.windowWidth > 600 ? <></> : <img className='footer-img' src={Logo} />}
                    <hr />
                </div>
                <FooterLarge minimal />
            </div>
        );
    }
}

export default withTranslation()(windowSize(MediaCenterImages));
